import Image from "next/image";
import IMAGES from "../../../../../images/importImages";
import { conditions, controllbarIconSize } from "../../../../../helpers";
import { ConditionName, IUnlockIconProps } from "../../../../../interfaces";
import { useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";

const UnlockIcon = (props: IUnlockIconProps) => {
    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params } }) => ({ videoElementSizeInfo, params }), shallowEqual);

    return (
        <>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i
                    className={`fa-solid pl-text-white fa-lock-open pl-cursor-pointer ${
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.otherFontAwesome
                            : controllbarIconSize.miniPlayerFontAwesome
                    }`}
                    {...props}
                />
            ) : (
                <Image
                    src={IMAGES.unlock}
                    alt="unlock-icon"
                    className="pl-cursor-pointer"
                    width={
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.other
                            : controllbarIconSize.miniPlayer
                    }
                    height={
                        conditions(ConditionName.isFullMobilePortrait) || !conditions(ConditionName.isMiniPlayer)
                            ? controllbarIconSize.other
                            : controllbarIconSize.miniPlayer
                    }
                    {...props}
                />
            )}
        </>
    );
};

export default UnlockIcon;
